import axios from "axios";
import { jwtDecode } from "jwt-decode"; // Incorrect import

const checkAuth = () => {
  const TOKEN = localStorage.getItem("token");

  // Return null if there is no token
  if (!TOKEN) {
    return null; // No token means the user is not authenticated
  }

  let decodedToken;
  try {
    // Decode the token and check for expiration
    decodedToken = jwtDecode(TOKEN);
    const currentTime = Date.now() / 1000; // Current time in seconds

    if (decodedToken.exp < currentTime) {
      localStorage.removeItem("token");
      return null; // Token is expired
    }
  } catch (error) {
    console.error("Failed to decode token:", error);
    localStorage.removeItem("token");
    return null; // Return null if there's an error in decoding
  }

  // Set the Authorization header for axios
  axios.defaults.headers.common['Authorization'] = `Bearer ${TOKEN}`;

  // Add request interceptor for loading indicator
  axios.interceptors.request.use(config => {
    document.body.classList.add('loading-indicator');
    return config;
  }, error => {
    return Promise.reject(error);
  });

  // Add response interceptor for loading indicator and error handling
  axios.interceptors.response.use(response => {
    document.body.classList.remove('loading-indicator');
    return response;
  }, error => {
    document.body.classList.remove('loading-indicator');
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      // Do not alert; just handle it silently
      console.error("Unauthorized access. Token may be invalid.");
    }
    return Promise.reject(error);
  });

  return TOKEN;
};

export default checkAuth;
